// Billing Constants

export const SET_BILLING_INFO = 'SET_BILLING_INFO';
export const SET_SAME_AS_SHIPPING = 'SET_SAME_AS_SHIPPING';
export const BILLING_RESET_FOR_REPEAT = 'BILLING_RESET_FOR_REPEAT';
